import { fetchWithAuth } from './apiUtils';
import { getAuthToken } from './authService';
import { API_URL } from '../constants/api';

const API_BASE_URL = `${API_URL}/users`;

/**
 * Servicio para gestión de usuarios
 */
const userService = {
  /**
   * Obtener todos los usuarios con paginación
   * @param {Object} options - Opciones de consulta
   * @param {number} options.page - Número de página (default: 1)
   * @param {number} options.limit - Elementos por página (default: 10)
   * @returns {Promise} - Promesa con la lista de usuarios paginada
   */
  async getAllUsers(options = {}) {
    const token = getAuthToken();
    
    // Construir parámetros de consulta
    const queryParams = new URLSearchParams();
    if (options.page) queryParams.append('page', options.page);
    if (options.limit) queryParams.append('limit', options.limit);
    
    const url = queryParams.toString() ? `${API_BASE_URL}?${queryParams}` : API_BASE_URL;
    return await fetchWithAuth(url, {}, token);
  },

  /**
   * Obtener estadísticas de usuarios
   * @returns {Promise} - Promesa con las estadísticas
   */
  async getUserStats() {
    const token = getAuthToken();
    return await fetchWithAuth(`${API_BASE_URL}/stats`, {}, token);
  },

  /**
   * Crear un nuevo usuario
   * @param {Object} userData - Datos del usuario
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  async createUser(userData) {
    const token = getAuthToken();
    return await fetchWithAuth(API_BASE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    }, token);
  },

  /**
   * Actualizar un usuario
   * @param {string} id - ID del usuario
   * @param {Object} userData - Datos actualizados del usuario
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  async updateUser(id, userData) {
    const token = getAuthToken();
    return await fetchWithAuth(`${API_BASE_URL}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    }, token);
  },

  /**
   * Eliminar un usuario
   * @param {string} id - ID del usuario
   * @returns {Promise} - Promesa con la respuesta del servidor
   */
  async deleteUser(id) {
    const token = getAuthToken();
    return await fetchWithAuth(`${API_BASE_URL}/${id}`, {
      method: 'DELETE',
    }, token);
  },
};

export default userService; 